function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { InfoFilled as InfoIcon } from "@churchofjesuschrist/eden-icons";
import { info10 } from "@churchofjesuschrist/eden-style-constants";
import Alert from "./Alert";

const Info = _ref => {
  let {
    children,
    onClose,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Alert, _extends({}, props, {
    color: info10,
    Icon: InfoIcon,
    onClose: onClose
  }), children);
};

Info.propTypes = {
  /** Content inside the alert body */
  children: PropTypes.node.isRequired,

  /** Callback function to execute when user dismisses the alert */
  onClose: PropTypes.func
};
export default Info;